interface TickWithWavyCircleProps {
  width?: string;
  height?: string;
  fillColor?: string;
}
const TickWithWavyCircle = (props: TickWithWavyCircleProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1891_39071)">
        <path
          d="M14.6673 7.39113V8.00447C14.6665 9.44208 14.201 10.8409 13.3402 11.9924C12.4794 13.1438 11.2695 13.9861 9.89089 14.3937C8.51227 14.8013 7.03882 14.7524 5.6903 14.2542C4.34177 13.756 3.19042 12.8352 2.40796 11.6292C1.6255 10.4232 1.25385 8.99651 1.34844 7.56201C1.44303 6.12751 1.99879 4.76202 2.93284 3.66918C3.86689 2.57635 5.12917 1.81472 6.53144 1.4979C7.93371 1.18107 9.40083 1.32602 10.714 1.91113M14.6673 2.66732L8.00065 9.34065L6.00065 7.34065"
          stroke="#5C5C5C"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1891_39071">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TickWithWavyCircle;
